import { defineFetch } from 'resift';

const makeGetWidgets = defineFetch({
  displayName: 'Get Widgets',
  make: () => ({
    request: (expandDefaultLayoutPresence?: boolean) => ({ http }) =>
      http({
        method: 'GET',
        route: `/widgets`,
        query: { expandDefaultLayoutPresence },
      }),
  }),
});

const getWidgets = makeGetWidgets();

export default getWidgets;
